<template>
<div id="outer">
  <div id="enforcer" :style="{'margin-top': (100/aspect/2)+'%' }"/>
  <div id="content"><slot/></div>
</div>
</template>

<script>
export default {
  name: 'AspectEnforcer',
  props: {
    format: { required: true },
  },
  computed: {
    aspect: function() {
      if (typeof(this.format)=='number') {
        return parseFloat(this.format)
      } else if (this.format=='a4') {
        return 210/297
      } else if (this.format=='a4r') {
        return 297/210
      } else if (this.format=='sq') {
        return 100/100
      } else if (this.format=='usr') {
        return 279.4 / 215.9
      } else {
        1.0
      }
    },
  },
}
</script>

<style scoped>
#outer {
    display: inline-block;
    width: 100%;
    position: absolute;
    position: relative;
}
#enforcer {
    position: relative;
}
#content {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
}
</style>



// WEBPACK FOOTER //
// src/components/AspectEnforcer.vue